import renderPage from '@helpers/renderPage';
import { flushSync } from 'react-dom';
const i18nData = $('#pageAttributes').data('custom_strings') || {};

const MessagePreview = ({
    message,
    onMessageClick,
    message_from_title,
    commentExpanded,
    messageDisabled,
    sendMessage,
    message_textbox_placeholder,
    messageLogs,
    logo,
}) => {
    const [showCompanyMessageLogsModal, setShowCompanyMessageLogsModalState] =
        React.useState(false);

    function closeModal() {
        setShowCompanyMessageLogsModalState(false);
    }

    return (
        <React.Fragment>
            <div className="send-message-container">
                {(message.length > 0 || messageLogs.length > 0) && (
                    <div className="preview-user-message">
                        {message.length > 0 && (
                            <React.Fragment>
                                <label className="message-from">
                                    <p>{message_from_title}:</p>
                                </label>
                                <div className="message">
                                    {message.length > 150 && !commentExpanded ? (
                                        <div>
                                            {message.substring(0, 150)}...
                                            <div>
                                                <a
                                                    href="#"
                                                    className="presentation-text-color"
                                                    onClick={() => onMessageClick(true)}
                                                >
                                                    {i18n_terms('show_more', i18nData)}{' '}
                                                </a>
                                            </div>
                                        </div>
                                    ) : (
                                        message
                                    )}
                                    {message.length > 150 && commentExpanded && (
                                        <div>
                                            <a
                                                href="#"
                                                className="presentation-text-color"
                                                onClick={() => onMessageClick(false)}
                                            >
                                                {i18n_terms('show_less', i18nData)}{' '}
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </React.Fragment>
                        )}
                        {messageLogs.length > 0 && (
                            <a
                                href="#"
                                className="btn btn-default show-all-message-text"
                                onClick={async () => {
                                    setShowCompanyMessageLogsModalState(true);
                                }}
                            >
                                <span className="icon-svg-mail-02"></span>
                                {i18n_terms('show_all_messages', i18nData)}
                            </a>
                        )}
                    </div>
                )}
                <div className="candidate-remarks">
                    {!messageDisabled && (
                        <div className="candidate-message-input">
                            <input
                                type="text"
                                id="messageField"
                                className="form-control"
                                placeholder={message_textbox_placeholder}
                            />
                            <button
                                type="button"
                                className=""
                                onClick={() => {
                                    const message = $('#messageField').val();
                                    $('#messageField').val('');
                                    sendMessage(message);
                                }}
                            >
                                {i18n_terms('send', i18nData)}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <ModalComponent
                show={showCompanyMessageLogsModal}
                closeModal={closeModal}
                className="intro-company-message-container overlay-close-no-confirmation"
                id="company-message-logs"
            >
                <div className="overlay">
                    <div className="overlay-header">
                        <h3>{i18n_terms('message_log_heading', i18nData)}</h3>
                    </div>
                    <div className="overlay-main">
                        <div className="intro-message-logs">
                            {messageLogs.length > 0 &&
                                messageLogs.map((msgLog, index) => {
                                    return (
                                        <div key={msgLog.timestamp || index} className="message-log">
                                            <div className="message-log-header">
                                                <div className="log-user">
                                                    <div className="user-info">
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: getPortraitHtml(
                                                                    msgLog.user_photo,
                                                                    msgLog.user_first_name ||
                                                                        msgLog.user_name,
                                                                    msgLog.user_last_name,
                                                                ),
                                                            }}
                                                        />
                                                        <span>
                                                            {i18n_terms('message_from', i18nData)}{' '}
                                                            <b>{msgLog.user_name}</b>
                                                        </span>
                                                    </div>
                                                    <p className="log-date text-right">
                                                        {iso_in_local(msgLog.timestamp, 'LLL')}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="message-log-body">
                                                <p>{msgLog.message}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                        {!messageDisabled && (
                            <div className="logs-email-to-company spacing-top-l">
                                <textarea
                                    id="message-preview-textarea"
                                    className="form-control"
                                    rows="3"
                                    placeholder={`${message_textbox_placeholder}...`}
                                ></textarea>
                                <div className="text-right spacing-top">
                                    <button
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={() => {
                                            const message = $('#message-preview-textarea').val();
                                            $('#message-preview-textarea').val('');
                                            sendMessage(message);
                                            closeModal();
                                        }}
                                    >
                                        {i18n_terms('send_email', i18nData)}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </ModalComponent>
        </React.Fragment>
    );
};

class ICPresentation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            presentationData: {},
            notesData: [],
            selectedCandidate: {},
            selectedCandidateAPI: {},
            selectedTemplate: 'template-1',
            selectedCandidateRating: 0,
            isInitialized: false,
            navigationURL: '',
            dtSearchData: {},
            nextCandidateId: '',
            prevCandidateId: '',
            navigationCurrentIndex: 0,
            navigationTotalIds: 0,
            commentExpanded: false,
            mode: 'view',
            messageLogs: [],
            candidateInActiveListing: false,
            isShareModalOpen: false,
            isInviteModalOpen: false,
            data: {},
            dataSchema: {},
        };
        this.candidateClick = this.candidateClick.bind(this);
        this.prevCandidate = this.prevCandidate.bind(this);
        this.nextCandidate = this.nextCandidate.bind(this);
        this.addNote = this.addNote.bind(this);
        this.setPriority = this.setPriority.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.deleteNote = this.deleteNote.bind(this);
        this.getNextRecordData = this.getNextRecordData.bind(this);
        this.publishIntroduction = this.publishIntroduction.bind(this);
        this.addSelectionCSS = this.addSelectionCSS.bind(this);
        this.setMode = this.setMode.bind(this);
        this.getMessageLogs = this.getMessageLogs.bind(this);
        this.toggleShareModal = this.toggleShareModal.bind(this);
        this.renderAlpacaForm = this.renderAlpacaForm.bind(this);
        this.changeFormValue = this.changeFormValue.bind(this);
        this.shareCandidateIntroduction = this.shareCandidateIntroduction.bind(this);
        this.expireCandidateIntroduction = this.expireCandidateIntroduction.bind(this);
        this.refetchPresentationData = this.refetchPresentationData.bind(this);
    }

    async componentDidMount() {
        const presentationData = await this.getPresentationData();
        const { id: presentationId } = presentationData;
        const candidateClick = this.candidateClick;
        const { candidate_introduction_messages_api } = this.props;
        this.getMessageLogs(candidate_introduction_messages_api);

        this.setState(
            {
                presentationData,
                data: _.get(presentationData, 'share_form.data', {}),
                dataSchema: _.get(presentationData, 'share_form', {}),
            },
            () => {
                setTimeout(() => {
                    this.renderAlpacaForm();
                    const { datatable_info } = this.props;
                    const {
                        datatables_columns,
                        datatables_default,
                        datatables_i18n,
                        enable_search,
                    } = datatable_info;
                    const initTableHeader = () => {
                        var tableHeaders = '';
                        $.each(datatables_columns, (i, val) => {
                            var hint = val.hint || '';
                            if (val.data === 'select') {
                                // td so Bootstrap center works
                                tableHeaders +=
                                    '<td class="text-center"><input value="1" ' +
                                    'class="select-all-checkbox" type="checkbox"></td>';
                            } else if (!hint) {
                                tableHeaders += '<th>' + (val.name || '') + '</th>';
                            } else {
                                tableHeaders +=
                                    '<th title="' +
                                    hint.replace('"', '&quot;') +
                                    '">' +
                                    (val.name || '') +
                                    '</th>';
                            }
                        });
                        $('.candidateTable thead').html('<tr>' + tableHeaders + '</tr>');
                    };

                    let column_defs = {};
                    datatables_columns.forEach((item) => {
                        column_defs[item['data']] = _.cloneDeep(item);
                    });
                    column_defs = ICColumnsDef(column_defs);

                    function getColumnDefs(columns) {
                        var definition,
                            defs = [];
                        for (var target = 0; target < columns.length; target++) {
                            definition = column_defs[columns[target]['data']];
                            if (definition) {
                                definition['targets'] = target;
                                defs.push(definition);
                            }
                        }
                        return defs;
                    }

                    const updateTable = (searchData = {}) => {
                        var $table = $('.candidateTable');
                        initTableHeader();

                        if (!searchData) return;

                        var columnDefs = getColumnDefs(datatables_columns);
                        var table = $table.DataTable({
                            processing: true,
                            serverSide: true,
                            destroy: true,
                            responsive: true,
                            searching: enable_search,
                            searchDelay: 500,
                            ordering: true,
                            autoWidth: false,
                            order: datatables_default.order,
                            lengthMenu: [20, 40, 60, 100],
                            pageLength: datatables_default.length,
                            orderMulti: true,
                            language: datatables_i18n,
                            fnInitComplete: (oSettings, json) => {
                                this.addSelectionCSS(table.$('tr')[0]);
                                this.setState({ dtSearchData: json, isInitialized: true });
                            },
                            dom:
                                "<'table-top-bar'<'table-info'f>>" +
                                '<tr>' +
                                "<'table-footer table-footer-sticky clearfix'<'table-footer-col table-length-info'l><'table-footer-col table-pagination-bottom'p>>",
                            rowCallback: function (row, data) {
                                if (data.errors) {
                                    if (data.errors.errors.length) {
                                        $(row).addClass('ta-error-bg-light');
                                    } else if (data.errors.warnings.length) {
                                        $(row).addClass('ta-warning-bg-light');
                                    }
                                }
                            },
                            columns: datatables_columns,
                            columnDefs: columnDefs,
                            ajax: (data, callback, settings) => {
                                $(this).find('tbody').empty();
                                const { presentationData, isInitialized } = this.state;
                                const { candidates: candidateOptions } = presentationData;
                                const { url: candidatesUrl, method: candidatesMethod } =
                                    candidateOptions._links.get;
                                if (isInitialized) {
                                    const cb = (data) => {
                                        // candidateInActiveListing
                                        let { data: candidates } = data;
                                        const isCandidateExist = candidates.some(
                                            ({ id }) =>
                                                id === _.get(this.state.selectedCandidate, 'id'),
                                        );
                                        this.setState(
                                            {
                                                candidateInActiveListing: isCandidateExist,
                                            },
                                            () => callback(data),
                                        );
                                    };
                                    this.getCandidates(candidatesUrl, candidatesMethod, cb, data);
                                } else {
                                    try {
                                        const extendedCallback = async (data) => {
                                            let { data: candidates } = data;
                                            candidates = candidates.map((value, index) =>
                                                Object.assign(value, { selectKey: index }),
                                            );
                                            const navigationURL = `/api/introductions/${presentationId}/navigation`;
                                            if (!_.isEmpty(candidates)) {
                                                const queryParams = new URLSearchParams(
                                                    window.location.search,
                                                );
                                                const introduced_candidate_id =
                                                    queryParams.get('introduced_candidate');
                                                let selectedCandidate = await this.getCandidateInfo(
                                                    candidates[0],
                                                );
                                                let candidateObj = candidates[0];

                                                if (introduced_candidate_id) {
                                                    candidateObj = candidates.find(
                                                        (candi) =>
                                                            candi.id === introduced_candidate_id,
                                                    );
                                                    if (candidateObj) {
                                                        selectedCandidate =
                                                            await this.getCandidateInfo(
                                                                candidateObj,
                                                            );
                                                    } else {
                                                        candidateObj = candidates[0];
                                                    }
                                                }
                                                const selectedCandidateAPI =
                                                    candidateObj._links.get;
                                                const candidateIdList = _.map(candidates, 'id');
                                                const {
                                                    prev_id: prevCandidateId,
                                                    next_id: nextCandidateId,
                                                    current_id_index: navigationCurrentIndex,
                                                    total_ids: navigationTotalIds,
                                                } = await this.getNextRecordData(
                                                    navigationURL,
                                                    candidateObj.id,
                                                    candidateIdList,
                                                );
                                                selectedCandidate.selectKey = 0;
                                                const notesData = await this.getCandidateNotes(
                                                    selectedCandidate,
                                                );
                                                this.setState(
                                                    {
                                                        selectedCandidate,
                                                        selectedCandidateAPI,
                                                        notesData,
                                                        selectedCandidateRating:
                                                            selectedCandidate.rating,
                                                        navigationURL,
                                                        prevCandidateId,
                                                        nextCandidateId,
                                                        navigationCurrentIndex,
                                                        navigationTotalIds,
                                                        candidateInActiveListing:
                                                            candidateIdList.indexOf(
                                                                candidateObj.id,
                                                            ) !== -1,
                                                    },
                                                    () => callback(data),
                                                );
                                            } else {
                                                callback(data);
                                            }
                                        };
                                        this.getCandidates(
                                            candidatesUrl,
                                            candidatesMethod,
                                            extendedCallback,
                                            data,
                                        );
                                    } catch (error) {
                                        console.error(error);
                                    }
                                }
                            },
                            drawCallback: function () {
                                if (table.data().length) {
                                    table.columns.adjust();
                                }
                            },
                        });
                        const that = this;
                        $('.candidateTable tbody').on('click', 'tr', function () {
                            var data = table.row(this).data();
                            if (!$(this).hasClass('selected')) {
                                that.resetSelectionCSS(table);
                                that.addSelectionCSS(this);
                                candidateClick(data);
                                that.forceUpdate();
                            }
                        });
                        this.setState({
                            tableInstance: table,
                        });
                    };
                    updateTable();
                }, 100);
            },
        );
    }

    async refetchPresentationData() {
        const presentationData = await this.getPresentationData();

        this.setState(
            {
                presentationData,
                data: _.get(presentationData, 'form.data', {}),
                dataSchema: _.get(presentationData, 'form', {}),
            },
            () => {
                this.renderAlpacaForm();
            },
        );
    }

    addSelectionCSS(row) {
        $(row).addClass('selected');
    }

    resetSelectionCSS(table) {
        table.$('tr.selected').removeClass('selected');
    }

    async getNextRecordData(navigationURL, selectedHash, hashList) {
        const parameters = {
            entity_ids: hashList,
            entity_hash: selectedHash,
        };
        const nextRecordData = await ajaxRequest('POST', navigationURL, parameters, {
            Accept: 'application/vnd.talentadore.v2+json',
        });
        return nextRecordData;
    }

    async getPresentationData() {
        const { candidate_introduction_api } = this.props;
        const presentationData = await ajaxRequest(
            'GET',
            candidate_introduction_api,
            undefined,
            'v2',
        );
        return presentationData;
    }

    async getCandidates(url, type, callback = () => {}, data) {
        try {
            const options = { datatables: data };
            const response = await ajaxRequest(type, url, JSON.stringify(options), 'v2');
            const { batch, total } = response;
            const dtSearchData = {
                draw: response.draw,
                recordsTotal: response.recordsTotal,
                recordsFiltered: response.recordsFiltered,
                pageLength: length,
                data: batch.map((val, int) => Object.assign(val, { selectKey: int })),
            };
            this.setState({ dtSearchData: dtSearchData }, () => callback(dtSearchData));
            return { candidates: batch, total, response };
        } catch (error) {
            callback({
                draw: data.draw,
                recordsTotal: 0,
                recordsFiltered: 0,
                pageLength: length,
                data: [],
            });
        }
    }

    async getCandidateInfo(candidate) {
        if (candidate) {
            const { url, method: type } = candidate._links.get;
            const candidateData = await ajaxRequest(type, url, {}, 'v2');
            return candidateData;
        }
        return {};
    }

    async getCandidateNotes(candidate) {
        const { notes } = candidate;
        if (!notes || !notes._links || !notes._links.get) {
            console.error('Cannot get notes: notes._links.get is undefined', candidate);
            return [];
        }
        const { url, method: type } = notes._links.get;
        const notesData = await ajaxRequest(type, url, {}, 'v2');
        return notesData;
    }

    async candidateClick(candidate) {
        const { dtSearchData, navigationURL } = this.state;
        const { data: candidates } = dtSearchData;
        const candidateIdList = _.map(candidates, 'id');
        let selectedCandidate = await this.getCandidateInfo(candidate);
        let candidateInActiveListing =
            selectedCandidate && candidateIdList.indexOf(selectedCandidate.id) !== -1;
        const notesData = await this.getCandidateNotes(selectedCandidate);
        const {
            next_id: nextCandidateId,
            prev_id: prevCandidateId,
            current_id_index: navigationCurrentIndex,
            total_ids: navigationTotalIds,
        } = await this.getNextRecordData(navigationURL, selectedCandidate.id, candidateIdList);
        flushSync(() => {
            this.setState({
                selectedCandidate,
                selectedCandidateRating: selectedCandidate.rating,
                notesData,
                nextCandidateId,
                prevCandidateId,
                navigationCurrentIndex,
                navigationTotalIds,
                candidateInActiveListing,
            });
        });
    }

    getTemplate(name, props) {
        let template = (
            <div>
                <h1>Undefined Template</h1>
            </div>
        );
        if (name == 'template-1') {
            return <IC_Template_1 {...props} />;
        }
        return template;
    }

    prevCandidate() {
        const { tableInstance: table, prevCandidateId, presentationData } = this.state;
        const { id: presentationId } = presentationData;
        if (table.$('tr.selected').prev().length > 0) {
            const prevRow = table.$('tr.selected').prev();
            const prevCandidateData = table.row(table.$('tr.selected').prev()).data();
            this.resetSelectionCSS(table);
            this.addSelectionCSS(prevRow);
            this.candidateClick(prevCandidateData);
        } else if (prevCandidateId) {
            this.resetSelectionCSS(table);
            const prevCandidateData = {
                _links: {
                    get: {
                        url: `/api/introductions/edit/${presentationId}/candidates/${prevCandidateId}`,
                        method: 'GET',
                    },
                },
            };
            this.candidateClick(prevCandidateData);
        }
        return false;
    }

    nextCandidate() {
        const { tableInstance: table, presentationData, nextCandidateId } = this.state;
        const { id: presentationId } = presentationData;
        if (table.$('tr.selected').next().length > 0) {
            const nextRow = table.$('tr.selected').next();
            const nextCandidateData = table.row(table.$('tr.selected').next()).data();
            this.resetSelectionCSS(table);
            this.addSelectionCSS(nextRow);
            this.candidateClick(nextCandidateData);
        } else if (nextCandidateId) {
            this.resetSelectionCSS(table);
            const nextCandidateData = {
                _links: {
                    get: {
                        url: `/api/introductions/edit/${presentationId}/candidates/${nextCandidateId}`,
                        method: 'GET',
                    },
                },
            };
            this.candidateClick(nextCandidateData);
        }
    }

    async addNote(text) {
        const { selectedCandidate } = this.state;
        if (!selectedCandidate || !selectedCandidate.notes || !selectedCandidate.notes._links || !selectedCandidate.notes._links.post) {
            console.error('Cannot add note: selectedCandidate.notes._links.post is undefined', {
                hasSelectedCandidate: !!selectedCandidate,
                hasNotes: !!selectedCandidate?.notes,
                hasLinks: !!selectedCandidate?.notes?._links,
                hasPost: !!selectedCandidate?.notes?._links?.post
            });
            return;
        }
        const { notes } = selectedCandidate;
        const { url, method: type } = notes._links.post;
        const options = JSON.stringify({ text });
        await ajaxRequest(type, url, options, 'v2');
        const notesData = await this.getCandidateNotes(selectedCandidate);
        flushSync(() => {
            this.setState({ notesData });
        });

        await new Promise(resolve => 
            requestAnimationFrame(() => 
                requestAnimationFrame(() => 
                    requestAnimationFrame(resolve)
                )
            )
        );
    }

    async setPriority(rating) {
        let { selectedCandidate } = this.state;
        const { rating_url } = selectedCandidate;
        const { url, method: type } = rating_url._links.post;
        const options = JSON.stringify({ rating });
        await ajaxRequest(type, url, options, 'v2');
        const { tableInstance } = this.state;
        tableInstance.ajax.reload(() => {
            const selectedRow = tableInstance.$('tr')[selectedCandidate.selectKey];
            this.addSelectionCSS(selectedRow);
        }, false);
        this.setState({
            selectedCandidateRating: rating,
        });
    }

    async sendMessage(message) {
        const { presentationData } = this.state;
        const { candidate_introduction_messages_api } = this.props;
        const { send_message_from_recipient } = presentationData;
        const { url, method: type } = send_message_from_recipient._links.get;
        const options = JSON.stringify({ message });
        const response = await ajaxRequest(type, url, options, 'v2');
        notification(response.notification, { type: 'success' });
        this.getMessageLogs(candidate_introduction_messages_api);
    }

    async deleteNote(note) {
        const { _links } = note;
        if (!_links || !_links.delete) {
            console.error('Cannot delete note: _links.delete is undefined', note);
            return;
        }
        const { url, method: type } = _links.delete;
        const deletedNote = await ajaxRequest(type, url, {}, 'v2');
        notification(deletedNote.notification, { type: 'success' });
        const { selectedCandidate } = this.state;
        const notesData = await this.getCandidateNotes(selectedCandidate);
        flushSync(() => {
            this.setState({ notesData });
        });

        await new Promise(resolve => 
            requestAnimationFrame(() => 
                requestAnimationFrame(() => 
                    requestAnimationFrame(resolve)
                )
            )
        );
    }

    async publishIntroduction() {
        const { presentationData } = this.state;
        const { publish } = presentationData;
        const { url, method: type } = publish._links.get;
        const publishIntro = await ajaxRequest(type, url, {}, 'v2');
        notification(publishIntro.notification, { type: 'success' });
        setTimeout(() => {
            location = '/introductions';
        }, 1000);
        return publishIntro;
    }

    async updateCollaboratorsRecipients(savedIntro) {
        const { data } = savedIntro.form;
        let { recipients: recipient, collaborators: collaborator } = data;

        const promiseOptions = {
            collaborator,
            recipient,
        };

        if (typeof recipients === 'string') {
            promiseOptions.recipient = [recipient];
        }
        if (typeof collaborators === 'string') {
            promiseOptions.collaborator = [collaborator];
        }
        const { post: endpoint } = savedIntro.collaborators._links;
        return ajaxRequest(endpoint.method, endpoint.url, JSON.stringify(promiseOptions), 'v2');
    }

    async shareCandidateIntroduction() {
        const { data, presentationData } = this.state;
        const saveIntroduction = _.get(
            presentationData,
            'introduction_save_and_share_api._links.put',
            {},
        );
        const shareIntroduction = _.get(presentationData, 'share_introduction_api._links.post', {});
        try {
            const response = await ajaxRequest(
                saveIntroduction.method,
                saveIntroduction.url,
                JSON.stringify(data),
                'v2',
            );
            await ajaxRequest(
                shareIntroduction.method,
                shareIntroduction.url,
                JSON.stringify(data),
                'v2',
            );
            notification(response.notification, { type: 'success' });
            this.refetchPresentationData();
            this.toggleShareModal(false);
        } catch (error) {
            if (_.get(error, 'error')) {
                notification(_.get(error, 'data.message'), { type: 'error' });
            } else if (error.notification) {
                notification(error.notification, { type: 'error' });
            }
            return false;
        }
    }

    async expireCandidateIntroduction() {
        show_confirmation_overlay(
            'expire_introduction',
            i18n_terms('Expire introduction', i18nData),
            i18n_terms('Recipients will not be able to see expired introduction', i18nData),
            { label: i18n_terms('cancel', i18nData) },
            {
                label: i18n_terms('confirm', i18nData),
                action: async () => {
                    const { presentationData } = this.state;
                    const expireIntroduction = _.get(
                        presentationData,
                        'expire_introduction_api._links.post',
                        {},
                    );
                    try {
                        response = await ajaxRequest(
                            expireIntroduction.method,
                            expireIntroduction.url,
                            {},
                            'v2',
                        );
                        notification(response.notification, { type: 'success' });
                        this.refetchPresentationData();
                        this.toggleShareModal(false);
                    } catch (error) {
                        if (_.get(error, 'error')) {
                            notification(_.get(error, 'data.message'), { type: 'error' });
                        } else if (error.notification) {
                            notification(error.notification, { type: 'error' });
                        }
                        return false;
                    }
                },
            },
        );
    }

    generateDynamicCSS(presentationData, messageDisabled) {
        const { color, title_color: title_color, cover_photo: coverPhoto } = presentationData;

        const customCSS = `
            .presentation-title-color {
                color: ${title_color} !important;
            }
            .presentation-text-color {
                color: ${color} !important;
            }
            .presentation-border-color {
                border-color: ${color} !important;
            }
            .presentation-border-text-color {
                border-color: ${color} !important;
                color: ${color} !important;
            }
            .presentation-background-color {
                background-color: ${color} !important;
            }
            .presentation-background-border-color {
                background-color: ${color} !important;
                border-color: ${color} !important;
            }
            .presentation-header-background {
                background: url('${coverPhoto || ''}') !important;
            }
            .presentation-message-input {
                background-color: ${messageDisabled ? '#565656' : color} !important;
            }
            #introduceCandidatePresentation .tabs a.is-active {
                color: ${color} !important;
            }
            #introduceCandidatePresentation .tabs a.is-active::after {
                background-color: ${color} !important;
            }
            #introduceCandidatePresentation .btn.btn-primary {
                background-color: ${color} !important;
                border-color: ${color} !important;
            }
            #introduceCandidatePresentation .btn.btn-ghost {
                color: ${color} !important;
                border-color: ${color} !important;
            }
        `;

        return <style> {customCSS} </style>;
    }

    async setMode(mode) {
        this.setState({ mode: mode });
        toggleSideBar(mode === 'evaluation');
    }

    async getMessageLogs(candidate_introduction_messages_api) {
        const messageLogs = await ajaxRequest(
            'GET',
            candidate_introduction_messages_api,
            undefined,
            'v2',
        );
        this.setState({ messageLogs: messageLogs });
    }

    toggleShareModal(isOpen) {
        this.setState({ isShareModalOpen: isOpen }, () => {
            if (isOpen) {
                this.renderAlpacaForm();
            }
        });
    }

    renderAlpacaForm() {
        const { presentationData } = this.state;
        const formHandler = new alpacaForm();
        if (_.isEmpty(presentationData.share_form)) {
            return false;
        }
        const dataSchema = structuredClone(presentationData.share_form);
        const that = this;
        $('#share-form').alpaca('destroy');
        formHandler.postRender = function () {
            return function (control) {
                const $container = control.domEl,
                    $form = $container.closest('.ta-form');

                formHandler.defaultPostRender(control);
                const $submitButtons = $form.find('[type="submit"]');
                $submitButtons.off('valid-click');
                $submitButtons.on('valid-click', (e, data) => {
                    that.shareCandidateIntroduction();
                    data.alwaysCb();
                    return false;
                });
            };
        };
        Object.keys(dataSchema['options']['fields']).forEach(function (key) {
            dataSchema['options']['fields'][key]['events'] = {
                change: function (event) {
                    event.preventDefault();
                    that.changeFormValue(this.name, this.getValue());
                },
            };
        });
        this.setState({ data: _.get(dataSchema, 'data', {}), dataSchema });
        formHandler.init(null, $('#share-form'));
        formHandler.updateJsonConfiguration(dataSchema);
    }

    changeFormValue(name, value) {
        const { data, dataSchema } = this.state;
        if (name === 'sharing_expiration') {
            data[name] = value.substring(0, 10);
        } else {
            data[name] = value;
        }
        if (dataSchema.schema.properties[name]) {
            dataSchema.schema.properties[name].default = value;
            this.setState({ data, dataSchema });
        } else {
            this.setState({ data });
        }
    }

    onAddUserHandler(user) {
        if (!$('#recipients').val().includes(user.email)) {
            var newOption = new Option(user.email, user.email, true, true);
            // Append it to the select
            $('#recipients').append(newOption).trigger('change');
        }
    }

    render() {
        const {
            selectedTemplate,
            presentationData,
            selectedCandidate,
            selectedCandidateAPI,
            notesData,
            selectedCandidateRating,
            commentExpanded,
            prevCandidateId,
            nextCandidateId,
            navigationCurrentIndex,
            navigationTotalIds,
            candidateInActiveListing,
            mode,
            messageLogs,
        } = this.state;

        const {
            structure: tabStructure,
            candidate_introduction_edit_template: backURL,
            view_type: viewType,
            message_textbox_placeholder,
            message_from_title,
            company_logo,
        } = this.props;

        let message = presentationData.message || '';

        const isCollaborator = viewType === 'collaborator';
        const messageDisabled = isCollaborator;
        const showMessageAccordion = isCollaborator ? !!(message || messageLogs.length) : true;
        const { company_user_form } = presentationData;
        const introductionStatus = _.get(presentationData, 'status_id');
        const canInviteRecipient =
            !!company_user_form && !presentationData.cannot_add_more_subusers && isCollaborator;
        let candidateListingContent = (
            <div className="candidate-table-container">
                <table className="table candidateTable"></table>
            </div>
        );

        return (
            <div className="listing-page intro-candidate-modal introduce-candidate-container">
                {this.generateDynamicCSS(presentationData, isCollaborator)}
                <div
                    className="listing-page__left-column introduce-candidate-sidebar listing-section-padding toggle-sidebar-container"
                    data-local_storage_prefix="candidate_introduction"
                >
                    <a id="toggle-sidebar-btn">
                        <span className="icon-svg-chevron-left"></span>
                    </a>
                    <div className="collapsible-container">
                        <div className="toggle-sidebar-content">
                            {isCollaborator && (
                                <div className="sidebar-content-header">
                                    <div className="ic-modal-back">
                                        <a
                                            href={backURL}
                                            className="btn btn-ghost"
                                            title={i18n_terms('edit_introduction_title', i18nData)}
                                        >
                                            <span className="icon-svg-edit-02"></span>
                                            {i18n_terms('edit_introduction_title', i18nData)}
                                        </a>
                                        <a
                                            onClick={() => this.toggleShareModal(true)}
                                            className="btn btn-primary"
                                            title={i18n_terms('share_introduction', i18nData)}
                                        >
                                            <span className="glyphicon glyphicon-share-alt"></span>
                                            {i18n_terms('share_introduction', i18nData)}
                                        </a>
                                    </div>
                                </div>
                            )}
                            <div className="sidebar-content-main">
                                <div className="sidebar-content-main-child">
                                    {showMessageAccordion &&
                                        AccordionComponent(
                                            'company-messages',
                                            i18n_terms('candidate_information_messages', i18nData),
                                            <MessagePreview
                                                message={message}
                                                commentExpanded={commentExpanded}
                                                messageDisabled={isCollaborator}
                                                message_from_title={message_from_title}
                                                logo={company_logo}
                                                sendMessage={(msg) => this.sendMessage(msg)}
                                                message_textbox_placeholder={
                                                    message_textbox_placeholder
                                                }
                                                onMessageClick={(state) =>
                                                    this.setState({ commentExpanded: state })
                                                }
                                                messageLogs={messageLogs}
                                            />,
                                            true,
                                            {
                                                extraClass: 'panel-body-bg',
                                                icon: 'icon-svg-mail-02',
                                            },
                                        )}
                                    {AccordionComponent(
                                        'candidate-listing',
                                        i18n_terms('candidate_listing', i18nData),
                                        candidateListingContent,
                                        true,
                                        {
                                            extraClass: 'panel-body-bg',
                                            icon: 'icon-svg-users-01',
                                        },
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="listing-page__right-column">
                    {this.getTemplate(selectedTemplate, {
                        data: presentationData,
                        notesData,
                        selectedCandidate,
                        selectedCandidateAPI,
                        selectedCandidateRating,
                        tabStructure,
                        messageDisabled,
                        introductionStatus,
                        message_from_title,
                        message_textbox_placeholder,
                        prevCandidateId,
                        nextCandidateId,
                        navigationCurrentIndex,
                        navigationTotalIds,
                        candidateInActiveListing,
                        mode,
                        prevCandidate: this.prevCandidate,
                        nextCandidate: this.nextCandidate,
                        addNote: this.addNote,
                        deleteNote: this.deleteNote,
                        setPriority: this.setPriority,
                        sendMessage: this.sendMessage,
                        openShareModal: () => this.toggleShareModal(true),
                        setMode: this.setMode,
                    })}
                    <ModalComponent
                        show={this.state.isShareModalOpen}
                        closeModal={() => this.toggleShareModal(false)}
                    >
                        <div className="ta-form">
                            <div className="overlay candidate-introduction-share-modal">
                                <div className="overlay-header">
                                    <h3>{i18n_terms('share_introduction', i18nData)}</h3>
                                </div>
                                <div className="overlay-main">
                                    <div id="share-form"></div>
                                    <div>
                                        {canInviteRecipient && (
                                            <a
                                                className="btn btn-primary"
                                                onClick={() =>
                                                    this.setState({
                                                        isInviteModalOpen: true,
                                                    })
                                                }
                                            >
                                                {i18n_terms('invite_recipient', i18nData)}
                                            </a>
                                        )}
                                    </div>
                                </div>
                                <div className="overlay-footer">
                                    <div className="btn-container">
                                        <button
                                            className="btn btn-ghost"
                                            onClick={() => this.toggleShareModal(false)}
                                        >
                                            {i18n_terms('cancel', i18nData)}
                                        </button>
                                        {introductionStatus !== 3 && (
                                            <button
                                                className="btn btn-primary expire_introduction"
                                                onClick={this.expireCandidateIntroduction}
                                            >
                                                {i18n_terms('Expire introduction', i18nData)}
                                            </button>
                                        )}
                                        <button type="submit" className="btn btn-primary">
                                            {i18n_terms('share_introduction', i18nData)}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalComponent>

                    <ModalComponent
                        show={this.state.isInviteModalOpen}
                        closeModal={() =>
                            this.setState({
                                isInviteModalOpen: false,
                            })
                        }
                    >
                        <div className="overlay add-user-modal">
                            <div className="overlay-header">
                                <h3>{i18n_terms('Company users', i18nData)}</h3>
                            </div>
                            <div className="overlay-main">
                                <CompanyUserForm
                                    onClose={() => this.setState({ isInviteModalOpen: false })}
                                    visible={
                                        !presentationData.cannot_add_more_subusers &&
                                        canInviteRecipient
                                    }
                                    form={presentationData.company_user_form}
                                    onSuccess={this.onAddUserHandler}
                                    translations={i18nData}
                                />
                            </div>
                        </div>
                    </ModalComponent>
                </div>
            </div>
        );
    }
}

window.renderICPresentation = (props = {}, id = 'introduceCandidatePresentation') => {
    renderPage(id, () => <ICPresentation {...props} />);
};

renderPage('introduceCandidatePresentation', () => {
    const props = $('#candidate-introduction-view-attributes').data();
    return <ICPresentation {...props} />;
});
